import {useIntl} from 'react-intl'
import {useMutation, useQueryClient} from 'react-query'
import {QUERIES} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {useQueryResponse} from '../../core/QueryResponseProvider'
import {deleteSelectedHazardManagements} from '../../core/_requests'

const HazardManagementListGrouping = () => {
  const intl = useIntl()
  const {selected, clearSelected} = useListView()
  const queryClient = useQueryClient()
  const {query} = useQueryResponse()

  const deleteSelectedItems = useMutation(() => deleteSelectedHazardManagements(selected), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries([`${QUERIES.WORKFLOW}-${query}`])
      clearSelected()
    },
  })

  return (
    <div className='d-flex justify-content-end align-items-center'>
      <div className='fw-bolder me-5'>
        <span className='me-2'>{selected.length}</span>{' '}
        {intl.formatMessage({id: 'TABLE.HEADER.SELECTED'})}
      </div>

      <button
        type='button'
        className='btn btn-danger'
        onClick={async () => await deleteSelectedItems.mutateAsync()}
      >
        {intl.formatMessage({id: 'TABLE.HEADER.DELETED_SELECTED'})}
      </button>
    </div>
  )
}

export {HazardManagementListGrouping}
